import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'app/hooks';
import { usePageTitle } from 'app/hooks';
import { createVacancy } from 'features/vacancies/vacanciesSlice';

import styles from './styles.module.scss';

const grades = ['Intern', 'Junior', 'Middle', 'Senior', 'Lead/Manager'];

export default function CreateVacancy() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [grade, setGrade] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  usePageTitle('Создать вакансию');

  const handleCreate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!title || !description || !grade) return;

    setIsSubmitting(true);
    setError(null);

    try {
      const res = await dispatch(
        createVacancy({
          title,
          description,
          category: 'IT',
          grade,
        })
      );

      if (res.payload && res.payload.statusCode && res.payload.statusCode !== 200) {
        setError('Что-то пошло не так. Попробуйте еще раз');
      } else {
        setTitle('');
        setDescription('');
        setGrade('');

        navigate(`/vacancies/${res.payload.id}`);
      }
    } catch (error) {
      setError('Что-то пошло не так. Попробуйте еще раз');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Создание вакансии</h2>
      <div className={styles.wrapper}>
        <form onSubmit={handleCreate}>
          <input
            type="text"
            placeholder="Название"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={styles.input}
            required
          />

          <textarea
            placeholder="Описание"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className={styles.textarea}
            rows={6}
            required
          />

          <select
            value={grade}
            onChange={(e) => setGrade(e.target.value)}
            className={styles.select}
            required
          >
            <option value="" disabled>
              Выберите грейд
            </option>
            {grades.map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
          <button 
            type="submit" 
            className={styles.button}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Создание...' : 'Создать'}
          </button>
          {error && (
            <div className={styles.error}>{error}</div>
          )}
        </form>
      </div>
    </div>
  );
}
